export default __webpack_public_path__ + "static/media/storyboard.ac48d179.png";